import "./../../Home/assets/css/fontawesome.css";
import "./../../Home/assets/css/templatemo-finance-business.css";
import "./../../Home/assets/css/owl.css";
import React, {useState} from "react";
import { Container,Row,Col, Button } from "react-bootstrap";
import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';

import service1 from './../../Home/assets/images/single_service_01.jpg';
import service2 from './../../Home/assets/images/single_service_02.jpg';
import service3 from './../../Home/assets/images/single_service_03.jpg';
import service4 from './../../Home/assets/images/single_service_04.jpg';
import { ClientStyles } from "../../Styles/ClientStyles";
import { useNavigate } from 'react-router-dom';


const TabContent = props => {
  const navigate = useNavigate();
    function handleExit() {
        props.updateTab('/Demo');
        navigate('/Demo');
        // Scroll to top of page when demo opens - use setTimeout to ensure navigation completes first
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }

    function handleAdminExit() {
      props.updateTab('/AdminDemo');
      navigate('/AdminDemo');
      // Scroll to top of page when admin demo opens - use setTimeout to ensure navigation completes first
      setTimeout(() => {
          window.scrollTo(0, 0);
      }, 100);
    }

  switch(props.service){
    case 'tab-1':
      return( 
        <>
        <img src={service1} alt=""/>
        <h4>Tasting Room Scheduler</h4>
        <p>Free yourself from the constraints of big companies trying to "get a piece of the bottle."  Our scheduler application is built in the Willamette Valley, for the Willamette Valley.  In a true cooperative approach, the pricing for each winery drops as more wineries sign up. </p>
        <br></br>
          <Button style={ClientStyles.demo.button} onClick={()=>handleExit()}>
            Demo
          </Button>
        </>
      );
    case 'admin':
      return(
        <>
        <img src={service1} alt=""/>
        <h4>Admin Portal</h4>
        <p>Free yourself from the constraints of big companies trying to "get a piece of the bottle."  Our scheduler application is built in the Willamette Valley, for the Willamette Valley.  In a true cooperative approach, the pricing for each winery drops as more wineries sign up. </p>
        <br></br>
          <Button style={ClientStyles.demo.button} onClick={()=>handleAdminExit()}>
            Admin Demo
          </Button>
        </>
      );
    case 'tab-2':
      return( 
        <>
        <img src={service2} alt=""/>
        <h4>Point of Sale Reporting and Integration</h4>
        <p>You'll no longer need to fight against the limitations of your point of sale system.  Through our integration, general and customized reporting will be available.</p>
        <br></br>

        </>
      );
    case 'tab-3':
      return( 
        <>
        <img src={service3} alt=""/>
        <h4>Customer Connection</h4>
        <p>When customers connect with the winery in the application it will open up a whole new world loyalty.  All while protecting a consumer's privacy, customers will share data and feedback with the consortium of wineries. </p>
        <br></br>
        </>
      );
    case 'tab-4':
      return( 
        <>
        <img src={service4} alt=""/>
        <h4>Automated Cellar Tracking</h4>
        <p>The new level of customer integration will allow for the automation of cellar tracking.  While at the winery, let the app know about a purchase and it will automatically show up in a customer's cellar.  
        <br></br>When a consumer drinks a bottle, complete the loop and let the winery know that a valued customer is in need of a refill!</p>
        </>
      );
  }


}

TabContent.defaultProps = {

}
TabContent.propTypes = {
  service: PropTypes.string,

  tab: PropTypes.string,
  updateTab:PropTypes.func,
}

const ServicesComponent = props => {

  function handleTabClick(selectedTab){
    props.updateService(selectedTab)
  }

    return(
   <>
        <div class="page-heading header-text">
            <div class="container">
                <div class="row">
                <div class="col-md-12">
                    <h1>Our Services</h1>
                    <span>Coming Soon</span>
                </div>
                </div>
            </div>
        </div>

      <div class="single-services">
        <div class="container">
          <div class="row" id="tabs">
            <div class="col-md-4">
              <ul>
                <li onClick={()=>handleTabClick("tab-1")}><a href='#tabs-1'>Tasting Room Scheduler <i class="fa fa-angle-right"></i></a></li>
                <li onClick={()=>handleTabClick("admin")}><a href='#admin'>Admin Pannel <i class="fa fa-angle-right"></i></a></li>
                <li onClick={()=>handleTabClick("tab-2")}><a href='#tabs-2'>PoS Reporting <i class="fa fa-angle-right"></i></a></li>
                <li onClick={()=>handleTabClick("tab-3")}><a href='#tabs-3'>Customer Connection <i class="fa fa-angle-right"></i></a></li>
                <li onClick={()=>handleTabClick("tab-4")}><a href='#tabs-4'>Automatic Cellaring <i class="fa fa-angle-right"></i></a></li>
              </ul>
            </div>
            <div class="col-md-8">
              <section class='tabs-content'>
                <TabContent 
                  service={props.service}
                  updateTab={props.updateTab}
                />
              </section>
            </div>
          </div>
        </div>
      </div>

      <br></br>
      <br></br>
      <br></br>

    

    </>
    );
}

ServicesComponent.defaultProps = {

}
ServicesComponent.propTypes = {
  service: PropTypes.string,
  updateService:PropTypes.func,

  tab: PropTypes.string,
  updateTab:PropTypes.func,
}

export default (ServicesComponent);
